module.exports = __webpack_public_path__ + "static/img/10005 (4).ec6ce78.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10005 (4).webp
// module id = eFv0
// module chunks = 14